import React, { useEffect } from "react"
// import { Detail } from '../../../Components/Photos/Detail';
import { Detail } from '../../../Components/Photos/Detail'


export const PhotoDetail = (props) => {
  const id = props.match.params.photoId;
  return (<Detail photoId={id} /> )
}